/**
 * Returns new values and new values information by merged strategy.
 * See {@link docs/worker}
 *
 * @property {string} strategy - one value from FILE_UPLOAD_OPTIONS
 * @property {string} values - current values
 * @property {array} data - csv parsed data array
 * */

export default (strategy, values = [], data = []) => {
    const output = {
        added: 0,
        removed: 0,
        values: [],
    };

    values = [...new Set(values)];
    data = [...new Set(data)];

    switch (strategy) {
        case 'replace':
            // returns only new values from data
            return {
                ...output,
                added: data.length,
                values: data,
            };

        case 'add': {
            // add new values from data to previous values
            const mergedData = [...new Set([...values, ...data])];
            return {
                ...output,
                added: mergedData.length - values.length,
                values: mergedData,
            };
        }
        case 'remove': {
            // remove all values includes in the data
            const updatedValues = values.filter(value => !data.includes(value));
            return {
                ...output,
                removed: values.length - updatedValues.length,
                values: updatedValues,
            };
        }

        default:
            throw new Error(`Invalid strategy ${strategy}`);
    }
};
